import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { getCurrentUser } from "./app/msgraphapi/graphService";
import { AppToastContainer } from "./components/AppToast.tsx";
import { useAppDispatch } from "./app/hooks.ts";
import {
  setMsGraphUser,
  setProfilePicture,
  setUserDesignation,
  setAppUserAccount,
  setIsImpersonating,
  setUserRoles,
} from "./app/auth/createAuthSlice.ts";
import { useEffect, useState } from "react";
import { routes } from "./routes.tsx";
import { getAccount } from "./app/accountService.ts";


function App() {
  const [isLoading, setIsLoading] = useState(true);


  const appDispatch = useAppDispatch();

  useEffect(() => {
    getCurrentUser().then(({ user, pictureUrl }) => {
      getAccount()
        .then((account) => {
          appDispatch(setMsGraphUser(user));
          appDispatch(setProfilePicture(pictureUrl));
          appDispatch(setUserDesignation(user?.jobTitle));
          appDispatch(setAppUserAccount(account));
          appDispatch(setUserRoles(account.data?.permissions?.roles || account.permissions?.roles));
          if (localStorage.getItem("impersonate")) {
            appDispatch(setIsImpersonating(true));
          }
          setIsLoading(false);
        })
        .catch((error) => {
          if (localStorage.getItem("impersonate")) {
            localStorage.removeItem("impersonate");
            getAccount()
              .then((fallbackAccount) => {
                appDispatch(setMsGraphUser(user));
                appDispatch(setProfilePicture(pictureUrl));
                appDispatch(setUserDesignation(user?.jobTitle));
                appDispatch(setAppUserAccount(fallbackAccount));
                appDispatch(setUserRoles(fallbackAccount.data?.permissions?.roles || fallbackAccount.permissions?.roles));
              })
              .catch((fallbackError) => {
                console.error("Error fetching fallback account", fallbackError);
              })
              .finally(() => {
                setIsLoading(false);
              });
            return;
          }

          console.error("Error fetching account", error);
          setIsLoading(false);
        });
    });
  }, [isLoading]);

  const router = createBrowserRouter(routes);

  return (
    !isLoading && (
      <>
        <div>
          <RouterProvider router={router}></RouterProvider>
        </div>
        <AppToastContainer />
      </>
    )
  );
}

export default App;
